import l from '@/vendor/logger'

export default {
  isExist (itemName) {
    return !(localStorage.getItem(itemName) === null)
  },

  load (itemName) {
    try {
      return this.isExist(itemName)
        ? JSON.parse(localStorage.getItem(itemName))
        : new Error('localStorageService/loadState/not_exist', itemName)
    } catch (err) {
      l.e('localStorageService/loadState', err)
    }
  },

  save (itemName, payload) {
    try {
      const serializedItem = JSON.stringify(payload)
      localStorage.setItem(itemName, serializedItem)
    } catch (err) {
      l.e('localStorageService/saveState', err)
    }
  },

  remove (itemName) {
    this.isExist(itemName)
      ? localStorage.removeItem(itemName)
      : l.e('localStorageService/removeItem/not_exist', itemName)
  }
}
